import { injectGlobal } from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import LabelTooltip from 'seedling/components/tooltips/label_tooltip';
import { colors, fontWeight } from 'seedling/constants';
import { InformationIcon } from 'seedling/icons';

export default class ScrollableDescriptionTooltip extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  };

  static defaultProps = {
    position: 'bottom',
  };

  render() {
    const { text, position, children } = this.props;

    return (
      <LabelTooltip
        theme="scrollable-information"
        text={text}
        position={position}
        hideOnClick={false}
        interactive
      >
        {children || <InformationIcon hoverColor={colors.mediumGrey} />}
      </LabelTooltip>
    );
  }
}

injectGlobal`
  .tippy-tooltip.scrollable-information-theme {
    background-color: white;
    box-shadow: 0 1px 15px rgba(0, 0, 0, .2);
    ${fontWeight('normal')}
    width: auto;
    padding: 0;
    text-align: left;
  }

  .tippy-tooltip.scrollable-information-theme .tippy-tooltip-content {
    max-height: 300px;
    max-width: 350px;
    overflow-y: auto;
    padding: 10px 15px;
    color: black;
  }

  .tippy-tooltip.scrollable-information-theme [x-circle] {
    background-color: white;
  }

  [x-placement^="bottom"] .tippy-tooltip.scrollable-information-theme > [x-arrow] {
    border-color: white transparent;
  }
  [x-placement^="top"] .tippy-tooltip.scrollable-information-theme > [x-arrow] {
    border-color: white transparent;
  }
  [x-placement^="left"] .tippy-tooltip.scrollable-information-theme > [x-arrow] {
    border-color: white transparent;
  }
  [x-placement^="right"] .tippy-tooltip.scrollable-information-theme > [x-arrow] {
    border-color: white transparent;
  }
`;
